import { useMemo } from 'react'
import { Trainer, Workout } from 'src/dao/core-dao'
import { useTrainers } from 'src/hook/use-trainers'
import { coreService } from 'src/service/core-service'
import { queryKeys } from 'src/util/query-keys'
import { useQuery } from '@tanstack/react-query'

const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000

type SuggestedWorkout = Workout & {
  trainer: Trainer | undefined
}

interface UseSuggestedWorkoutsReturnType {
  suggestedWorkouts: SuggestedWorkout[]
  isLoading: boolean
}

export const useSuggestedWorkouts = (): UseSuggestedWorkoutsReturnType => {
  const { data: trainers = [] } = useTrainers()

  const { data: workouts = [], isLoading } = useQuery<Workout[], Error>(
    queryKeys.suggestedWorkouts(),
    () => coreService.getSuggestedWorkouts(),
    {
      staleTime: TWENTY_FOUR_HOURS_MS,
      refetchOnWindowFocus: false,
    },
  )

  const suggestedWorkouts = useMemo(
    () =>
      workouts.map((workout) => ({
        ...workout,
        trainer:
          workout.trainers && workout.trainers.length > 0
            ? trainers.find((trainer) => trainer.id === workout.trainers[0].id)
            : undefined,
      })),
    [workouts, trainers],
  )

  return { suggestedWorkouts, isLoading }
}
